import { combineReducers } from 'redux';

import { oldDashboardReducer } from './OldDashboard';
import { dashboardPageReducer } from './DashboardPage';
import { billingReducer } from './Billing';
import { billingDetailsReducer } from './BillingDetails';
import { passwordPageReducer } from './PasswordPage';
import { mobileNumberPageReducer } from './MobileNumberPage';
import { policyReducer } from './Policy';
import { policyDetailsReducer } from './PolicyDetails';
import { insuranceClaimListPageReducer } from './InsuranceClaimListPage';
import { insuranceClaimDetailsPageReducer } from './InsuranceClaimDetailsPage';
import { PolicyClaimReducer } from './PolicyClaim';
import { policyRenewalReducer } from './PolicyRenewal';
import { personalInfoEditReducer } from './PersonalInfoEditPage';
import { insurancePolicyListPageReducer } from './InsurancePolicyListPage';
import { insurancePolicyDetailsPageReducer } from './InsurancePolicyDetailsPage';
import { insurancePolicyUserDetailsPageReducer } from './InsurancePolicyUserDetailsPage';
import { insuranceClaimEditModalReducer } from './InsuranceClaimEditModal';
import { searchInsurancePolicyUserPageReducer } from './SearchInsurancePolicyUserPage';

export default combineReducers({
  oldDashboardReducer,
  dashboardPageReducer,
  billingReducer,
  billingDetailsReducer,
  passwordPageReducer,
  mobileNumberPageReducer,
  policyReducer,
  policyDetailsReducer,
  insuranceClaimListPageReducer,
  insuranceClaimDetailsPageReducer,
  policyClaim: PolicyClaimReducer,
  policyRenewalReducer,
  personalInfoEditReducer,
  insurancePolicyListPageReducer,
  insurancePolicyDetailsPageReducer,
  insurancePolicyUserDetailsPageReducer,
  insuranceClaimEditModalReducer,
  searchInsurancePolicyUserPageReducer,
});
